module.exports = __webpack_public_path__ + "static/media/MoPaaSai.c646698.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/MoPaaSai.mp4
// module id = OeWo
// module chunks = 0